import DsvModalShell from "./DsvModalShell";
import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import rem from "@/utils/rem.js";

const SEMVER_RE = /^\d+\.\d+\.\d+$/;

function EditVersionNumberModal({ visible, hide, version, onConfirm, serverError }) {
	const [value, setValue] = useState('');
	const [error, setError] = useState('');

	useEffect(() => {
		if (visible && version) {
			setValue(version.version || '');
			setError('');
		}
	}, [visible, version]);

	if (!version) return null;

	function handleSave() {
		const next = value.trim();
		if (!SEMVER_RE.test(next)) {
			setError('Version must be in the form X.Y.Z (e.g. 1.0.0).');
			return;
		}
		if (next === version.version) {
			setError('Enter a different version number.');
			return;
		}
		onConfirm(version, next);
	}

	return (
		<DsvModalShell
			visible={visible}
			hide={hide}
			title="Edit Version Number"
			actions={
				<button
					className="dsv-btn dsv-btn--promote"
					style={{ marginLeft: rem(12) }}
					data-testid="confirm-edit-version-btn"
					onClick={handleSave}
				>
					Save
				</button>
			}
		>
			<p className="dsv-confirm__subtitle">
				Editing the number of draft <strong>v{version.version}</strong>. Nothing else changes.
			</p>
			<h3 className="dsv-confirm__section-title">New version number</h3>
			<p className="dsv-promote__hint">Format: X.Y.Z (e.g. 1.0.0)</p>
			<input
				className="dsv-modal__input"
				data-testid="edit-version-input"
				type="text"
				value={value}
				onChange={(e) => { setValue(e.target.value); setError(''); }}
			/>
			{(error || serverError) && (
				<p className="dsv-promote__hint" data-testid="edit-version-error" style={{ color: '#b45309' }}>
					{error || serverError}
				</p>
			)}
		</DsvModalShell>
	);
}

EditVersionNumberModal.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func,
	version: PropTypes.object,
	onConfirm: PropTypes.func,
	serverError: PropTypes.string,
};

export default EditVersionNumberModal;
